import { render, staticRenderFns } from "./RuKuDan.vue?vue&type=template&id=1a59c0c3&scoped=true&"
import script from "./RuKuDan.vue?vue&type=script&lang=js&"
export * from "./RuKuDan.vue?vue&type=script&lang=js&"
import style0 from "./RuKuDan.vue?vue&type=style&index=0&id=1a59c0c3&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a59c0c3",
  null
  
)

export default component.exports